let video = document.getElementsByClassName('video-player');
let placeholder = document.getElementsByClassName('video__video');

for (let i = 0; i < video.length; i++) {
    video[i].addEventListener('click', function() {
        var video2 = '<iframe src="' + video[i].getAttribute('data-video') +'&autoplay=1" allow="autoplay"></iframe>';
        video[i].classList.add('close');
        video[i].parentElement.classList.add('closed');
        placeholder[i].innerHTML = video2;
    })
}